import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getMarketsSnapshot } from '../markets-snapshot.routes';
import { MarketData } from '../types';

export const useMarketsSnapshot = (
  positionDate: string | undefined,
  options?: Omit<
    UseQueryOptions<MarketData[], Error>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
) =>
  useQuery({
    queryKey: ['markets-snapshot', positionDate],
    queryFn: () => getMarketsSnapshot(positionDate!),
    enabled: !!positionDate,
    ...options,
  });
